import { render, staticRenderFns } from "./ProfitReportTotalAdmin.vue?vue&type=template&id=764b8898&scoped=true"
import script from "./ProfitReportTotalAdmin.vue?vue&type=script&lang=js"
export * from "./ProfitReportTotalAdmin.vue?vue&type=script&lang=js"
import style0 from "./ProfitReportTotalAdmin.vue?vue&type=style&index=0&id=764b8898&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764b8898",
  null
  
)

export default component.exports